export const getFirstLetter = (name) => name.trim().substring(0, 1).toUpperCase();
